import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";

const EddSectionCard = ({ title, subtitle, action, children, sx = {} }) => {
  const theme = useTheme();

  return (
    <Box
      mb={8}
      p={4}
      sx={{
        borderRadius: "12px",
        border: `1px solid ${theme.palette.grey["400"]}`,
        ...sx,
      }}
    >
      {(title || action) && (
        <Box
          mb={4}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box>
            {title && (
              <Typography fontSize={18} fontWeight="bold">
                {title}
              </Typography>
            )}
            {subtitle && (
              <Typography fontSize={14} color="text.secondary">
                {subtitle}
              </Typography>
            )}
          </Box>
          {action}
        </Box>
      )}
      {children}
    </Box>
  );
};

EddSectionCard.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  action: PropTypes.node,
  children: PropTypes.node,
  sx: PropTypes.object,
};

export default EddSectionCard;
